import { render, staticRenderFns } from "./CaptionJoinlff.vue?vue&type=template&id=f2de2380&scoped=true&"
import script from "./CaptionJoinlff.vue?vue&type=script&lang=js&"
export * from "./CaptionJoinlff.vue?vue&type=script&lang=js&"
import style0 from "./CaptionJoinlff.vue?vue&type=style&index=0&id=f2de2380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2de2380",
  null
  
)

export default component.exports